import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { selectBookmarkedIcon } from '@epicuro-next/platform/configuration';
import { selectActiveListId } from '@epicuro-next/state/product-list-state';
import {
  setAsideMenuOpenedState,
  setMainHeaderHeight,
} from '@epicuro-next/state/user-ui-state';
import { select, Store } from '@ngrx/store';
import { fromEvent, Subject } from 'rxjs';
import { debounceTime, map, takeUntil } from 'rxjs/operators';

import { BaseNavigationComponent } from '../base-navigation.component';
import { NavigationService } from '../service/navigation.service';

@Component({
  selector: 'epc-full-header',
  templateUrl: './full-header.component.html',
  styleUrls: ['./full-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FullHeaderComponent
  extends BaseNavigationComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  public navigationPoints = [this.homeLink, this.productsLink];

  @ViewChild('container') private elementView: ElementRef;

  public bookmarkIcon$ = this.store.pipe(select(selectBookmarkedIcon));

  public myListLink$ = this.store.pipe(
    select(selectActiveListId),
    map((activeListId) => ({
      ...this.myListsLink,
      activeListId,
      route: activeListId
        ? `${this.myListsLink.route}/${activeListId}`
        : this.myListsLink.route,
    })),
  );

  private destroy$ = new Subject<void>();

  constructor(store: Store, navigationService: NavigationService) {
    super(store, navigationService);
  }

  public ngOnInit() {
    this.initProductLists();
  }

  public ngAfterViewInit() {
    this.setMainHeaderHeight();
    fromEvent(window, 'resize')
      .pipe(debounceTime(200), takeUntil(this.destroy$))
      .subscribe(() => this.setMainHeaderHeight());
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public openAsideMenu() {
    this.store.dispatch(setAsideMenuOpenedState({ opened: true }));
  }

  protected setMainHeaderHeight() {
    const height = this.elementView.nativeElement.offsetHeight;
    this.store.dispatch(setMainHeaderHeight({ height }));
  }
}
